export const ThemeData = [
  {
    name: '저평가주',
    image: '/assets/images/quant/quant1.png',
    description: '시세보다 저평가된 물건',
    url: '',
  },
  {
    name: '공시지가보다낮주',
    image: '/assets/images/quant/quant2.png',
    description: '공시지가보다 싸게 살 수 있는 물건',
    url: '',
  },
  {
    name: '전세가보다낮주',
    image: '/assets/images/quant/quant3.png',
    description: '전세보증금보다 싸게 살 수 있는 물건',
    url: '',
  },
  {
    name: '전세우위주',
    image: '/assets/images/quant/quant4.png',
    description: '아파트 대상 전세놓기 좋은 지역의 물건',
    url: '',
  },
  {
    name: '월세우위주',
    image: '/assets/images/quant/quant5.png',
    description: '아파트 대상 월세놓기 좋은 지역의 물건',
    url: '',
  },
  {
    name: '평균보다낮주',
    image: '/assets/images/quant/quant6.png',
    description: '인근 지역 평균 시세보다 저평가된 물건',
    url: '',
  },
  {
    name: '하자없주',
    image: '/assets/images/quant/quant7.png',
    description: '대항력 등 권리상 하자가 없는 물건',
    url: '',
  },
  {
    name: '시세차익주',
    image: '/assets/images/quant/quant8.png',
    description: '시세차익 가능성이 높은 물건',
    url: '',
  },
  {
    name: '저평가부실채권주',
    image: '/assets/images/quant/quant9.png',
    description: '부실채권 대상 시세보다 저평가된 물건',
    url: '',
  },
  {
    name: '소액투자주',
    image: '/assets/images/quant/quant10.png',
    description: '소액투자(~3천만원) 가능한 물건',
    url: '',
  },
  {
    name: '시세상승주',
    image: '/assets/images/quant/quant11.png',
    description: '최근 실거래가가 상승하는 지역의 물건',
    url: '',
  },
  {
    name: '이자보다월세주',
    image: '/assets/images/quant/quant12.png',
    description: '월대출이자보다 월세 수익 가능성이 높은 물건',
    url: '',
  },
];

export const RegionData = [
  '전국',
  '서울',
  '경기',
  '인천',
  '부산',
  '대전',
  '대구',
  '울산',
  '세종',
  '강원',
  '충북',
  '충남',
  '경북',
  '경남',
  '광주',
  '전북',
  '전남',
  '제주',
];

export const CategoryData = [
  { name: '물건 전체', image: 'JU' },
  { name: '아파트', image: 'A' },
  { name: '빌라/다세대', image: 'B' },
  { name: '다가구', image: 'D' },
  { name: '주거 기타', image: 'JO' },
  { name: '오피스텔', image: 'O' },
  { name: '근생', image: 'G' },
  { name: '빌딩', image: 'BI' },
  { name: '지식산업센터', image: 'JI' },
  { name: '산업 기타', image: 'S' },
  { name: '대지', image: 'DA' },
  { name: '농지', image: 'N' },
  { name: '토지 기타', image: 'T' },
];
